import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

import { AGE_GATE_QUERY_KEY } from '@jane/bloom/utils/queryParams/queryParams';

export function useAgeGatePreview() {
  const [searchParams, setSearchParams] = useSearchParams();

  const removeAgeGatePreview = useCallback(() => {
    searchParams.delete(AGE_GATE_QUERY_KEY);
    setSearchParams(searchParams);
  }, [searchParams, setSearchParams]);

  return {
    removeAgeGatePreview,
    shouldPreviewAgeGate: searchParams.get(AGE_GATE_QUERY_KEY) === 'true',
  };
}
